const FLAG_KEY = '_cavenders_analytics_consent_granted'

function setFlag(value) {
    if (typeof window === 'undefined' || !window.localStorage) return
    if (value) {
        window.localStorage.setItem(FLAG_KEY, 'true')
    } else {
        window.localStorage.removeItem(FLAG_KEY)
    }
}

function getFlag() {
    if (typeof window === 'undefined' || !window.localStorage) return false
    return window.localStorage.getItem(FLAG_KEY) === 'true'
}

export function hasAnalyticsConsent() {
    if (typeof window === 'undefined') return false
    return getFlag()
}

export function subscribeToConsentChanges(callback) {
    if (typeof window === 'undefined') return () => {}

    let isListening = true

    const handleClick = (event) => {
        if (!isListening) return

        const target = event.target
        if (!target) return

        const element = target.closest('button, a, [role="button"]')
        if (!element) return

        const text = (element.textContent || '').toLowerCase().trim()
        const id = (element.id || '').toLowerCase()
        const className = (element.className || '').toLowerCase()
        const dataAction =
            element.getAttribute('data-action') || element.getAttribute('data-ketch-action') || ''

        const isAcceptButton =
            text.includes('accept') ||
            id.includes('accept') ||
            className.includes('accept') ||
            dataAction.toLowerCase().includes('accept')

        if (isAcceptButton) {
            const container = element.closest(
                '[id*="ketch"], [class*="ketch"], [data-ketch], [id*="consent"], [class*="consent"]'
            )
            if (container || document.querySelector('[id*="ketch"], [class*="ketch"]')) {
                setFlag(true)
                callback(true)
                isListening = false
            }
        }
    }

    document.addEventListener('click', handleClick, true)

    return () => {
        isListening = false
        document.removeEventListener('click', handleClick, true)
    }
}
